import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { TableHeadersType } from "../../constant/tableHeadersConstants/tableHeadersType";
import { CircularAvatar, EmptyListPage, TableHeader } from "../commons";
import { ViewTeamMembersDataType } from "../../redux/mySpace/mySpaceTypes";

type TabsType = {
  name: string;
  label: string;
  display: boolean | undefined;
};
export const VIEW_MY_TEAM_MEMBERS_HEADERS: TableHeadersType[] = [
  {
    label: "EMPLOYEE ID",
    value: "employee_id",
  },
  {
    label: "NAME",
    value: "name",
  },
  {
    label: "CONTACT",
    value: "contact",
  },
];
type AppProps = {
  toggle: () => void;
  isOpen: boolean;
  data: ViewTeamMembersDataType[] | [];
  totalCount: number;
  tabs: TabsType[];
  activeTab: string;
  setActiveTab: any;
};
const ViewTeamMembersModal = ({
  // history
  toggle,
  isOpen,
  data,
  totalCount,
  tabs,
  activeTab,
  setActiveTab,
}: AppProps) => {
  const [activeComponent, setActiveComponent] = useState<any>();
  const [finalTab, setFinalTab] = useState(tabs);

  useEffect(() => {
    if (activeTab === "reporting_person") {
      setActiveTab(tabs[0].label);
    } else {
      setActiveTab(tabs[1].label);
    }
  }, [activeTab, setActiveTab]);

  const handleTabChange = (tabs: string) => {
    setActiveTab(tabs);
  };

  const renderTabs = () => {
    const finalTab = tabs?.map((tab: TabsType) => {
      return (
        <div
          key={tab?.label}
          className={tab.display ? "tab-style mr-4 pointer" : "pointer"}
          onClick={() => {
            handleTabChange(tab?.label);
          }}
        >
          <div
            style={{
              padding: "12px 16px 12px 5px",
              color: activeTab === tab?.label ? "#dd4433" : "",
              fontSize: "16px",
            }}
            className={`tab-header ${activeTab === tab?.label ? "active" : ""}`}
          >
            {tab?.name}
          </div>
          <div
            style={{
              height: "3px",
            }}
            className={`${
              activeTab === tab?.label
                ? "active-tab-bottom-border"
                : "not-active-tab-bottom-border"
            }`}
          ></div>
        </div>
      );
    });
    return finalTab;
  };

  return (
    <>
        <Modal
      centered
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      style={{
        maxWidth: "650px",
        width: "100%",
      }}
      backdrop="static"
    >
      <ModalHeader
        className="pt-3 pl-4 pb-3"
        id="cross-cut"
        toggle={toggle}
        style={{
          maxWidth: "650px",
          width: "100%",
        }}
      >
        My Team
      </ModalHeader>

      <div className="col-md-12 mt-2">
        <div
          style={{
            borderRadius: "5px 5px 0 0",
            padding: "0px 15px",
            borderBottom: "1px solid #bfcbe1",
          }}
        >
          <div
            className="d-flex align-items-center"
            style={{ justifyContent: "space-between" }}
          >
            <div className="d-flex">{renderTabs()}</div>
          </div>
        </div>
      </div>


        {data.length === 0 ? (
          <div style={{padding: "40px 0px 40px 0px"}}>
              <EmptyListPage title="No List Found!" imageWidth="50%" />
          </div>
          ) : (
            <ModalBody
            style={{ height: "400px", padding: "1rem 0 1rem 0", overflowY: "auto" }}
          >
            <div
              className="mb-3 pl-4"
              style={{ color: "#6e7491", marginLeft: "5px" }}
            >
              {`Total ${totalCount} employees ${activeTab==="coach"?"in coaching.":"are reporting to you."} `}
            </div>
            <div className="disbursment table-responsive" style={{ width: "100%" }}>
          <table className="table">
            <thead className="sticky-table-header">
              <TableHeader tableHeader={VIEW_MY_TEAM_MEMBERS_HEADERS} />
            </thead>
            <tbody>
              {data?.length > 0 &&
                data?.map((el: ViewTeamMembersDataType) => {
                  return (
                    <tr className="text-left" style={{ paddingLeft: "20px" }}>
                      {VIEW_MY_TEAM_MEMBERS_HEADERS?.length > 0 &&
                        VIEW_MY_TEAM_MEMBERS_HEADERS?.map(
                          (header: TableHeadersType) => {
                            if (header?.value === "employee_id") {
                              return (
                                <td
                                  className="text-left"
                                  style={{
                                    minWidth: "150px",
                                    paddingLeft: "15px",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "left",
                                      alignItems: "center",
                                      gap: "14px",
                                      paddingLeft: "10px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <span style={{ fontSize: "14px" }}>
                                        {el?.employee_id
                                          ? el?.employee_id
                                          : "--/--"}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                              );
                            } else if (header?.value === "name") {
                              return (
                                <td
                                  className="text-left"
                                  style={{ minWidth: "227px" }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "left",
                                      alignItems: "center",
                                      gap: "3px",
                                      paddingLeft: "10px",
                                    }}
                                  >
                                    <div
                                    style={{
                                      minWidth:"35px",
                                      minHeight: "35px"
                                    }}>
                                    <CircularAvatar
                                      name={`${el?.name} `}
                                      image={
                                        el?.profile_pic &&
                                        el?.profile_pic?.file_url
                                      }
                                    />
                                    </div>
                                    
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <span style={{ fontSize: "14px" }}>
                                        {el?.name}
                                      </span>
                                      <span
                                        style={{
                                          color: "#6e7491",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {el?.job_title ? el?.job_title : ""}
                                        {el?.department
                                          ? `, ${el?.department}`
                                          : ""}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                              );
                            } else if (header?.value === "contact") {
                              return (
                                <td
                                  className="text-left"
                                  style={{ minWidth: "200px",
                                    overflowWrap: "anywhere",
                                   }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "left",
                                      alignItems: "center",
                                      gap: "10px",
                                      paddingLeft: "10px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <span>
                                        {el?.email_id ? el?.email_id : ""}
                                      </span>
                                      <span
                                        style={{
                                          color: "#6e7491",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {el?.mobile_no ? el?.mobile_no : ""}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                              );
                            }
                            return null;
                          }
                        )}
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
          
        

      </ModalBody>
      )}
    </Modal>
    </>

  );
};

export default ViewTeamMembersModal;
